import React from 'react';
import styled from 'styled-components';

import Tab from '@mui/material/Tab';
import TabList from '@mui/lab/TabList';

import { useTheme } from '../../../styles/theme';
import { Command } from '@store/slices';
import { SendOutlined } from '@mui/icons-material';

export const TabContainer = styled.div<{ color?: string }>`
  padding: 0 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.line.light};

  & .MuiSvgIcon-root {
    font-size: 17px;
  }

  & .Mui-selected {
    color: ${({ theme, color }) => (color ? color : theme.telnyx.green)} !important;
  }

  & .MuiTabs-root {
    max-height: 50px;
    min-height: 50px;
  }

  & .MuiTab-root {
    display: flex;
    font-family: 'PPFormula';
    padding: 0 10px;
    max-height: 60px;
    min-width: 20px;
    min-height: 60px;
    margin-right: 4px;
    font-size: 11px !important;
  }

  & .MuiTabs-indicator {
    background-color: ${({ theme, color }) => (color ? color : theme.telnyx.green)} !important;
  }
`;

interface Props {
  command?: Command;
  setTab: React.Dispatch<string>;
  showMessages?: boolean;
}

export const ChatbotTabs: React.FC<Props> = ({ setTab, showMessages = true }) => {
  const theme = useTheme();

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTab(newValue);
  };

  return (
    <TabContainer color={theme.primary}>
      <TabList onChange={handleChange}>
        <Tab disableRipple label='Events' value='1' />
        {showMessages && <Tab disableRipple title='Send Chat' icon={<SendOutlined />} iconPosition='start' value='2' />}
      </TabList>
    </TabContainer>
  );
};
